// extracted by mini-css-extract-plugin
module.exports = {"container":"warn-trend_container_1-BDS","chartBox":"warn-trend_chartBox_3U8mo"};